import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { quarterToRoman } from '@/shared/lib/utils/numberFormatters';
export default /*#__PURE__*/_defineComponent({
  __name: 'CompletionDateOutput',
  props: {
    input: null,
    type: {
      default: 'short'
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var readyQuarter = computed(function () {
      var _props$input;
      var _ref = (_props$input = props.input) !== null && _props$input !== void 0 ? _props$input : {},
        rq = _ref.readyQuarter;
      return rq ? quarterToRoman(Number(rq)) : undefined;
    });
    var builtYear = computed(function () {
      var _props$input2;
      return (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : _props$input2.builtYear;
    });
    var quarterPostfix = computed(function () {
      var _postfix$props$type;
      var postfix = {
        long: 'квартал',
        short: 'кв.'
      };
      return (_postfix$props$type = postfix[props.type]) !== null && _postfix$props$type !== void 0 ? _postfix$props$type : 'кв.';
    });
    return {
      __sfc: true,
      props: props,
      readyQuarter: readyQuarter,
      builtYear: builtYear,
      quarterPostfix: quarterPostfix
    };
  }
});